import { DialogContent, Divider, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import { DialogInfoGraphic } from '@bloomfieldrobotics/canopy';
import measurableBerriesImage from '../images/MeasureableBerriesInfo.jpg';

export const MeasurableBerriesInfoDialog = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <DialogInfoGraphic
      imgSrc={measurableBerriesImage}
      open={open}
      onClose={onClose}
    >
      <DialogContent>
        <Stack
          justifyContent={'space-between'}
          spacing={'1rem'}
          padding={'0 2rem'}
        >
          <Typography fontWeight={700} fontSize={'1rem'}>
            {t('Measuring Berries')}
          </Typography>
          <Typography
            sx={{
              fontSize: '0.875rem',
              color: (theme) => theme.colors.canopy.text.primary,
            }}
          >
            <Trans t={t} i18nKey={'measurableBerriesInfo'}>
              Our capabilities can accurately count and measure the width of{' '}
              <strong>fully visible</strong> blueberries; however, it is
              currently limited in measuring berries obscured by foliage,
              branches, or overlapping fruit, leading to potential
              underestimation in areas of dense clusters. This limitation may
              result in incomplete data on berry size and count in visually
              obstructed images.
            </Trans>
          </Typography>
        </Stack>
      </DialogContent>
      <Divider sx={{ color: '#2B2B2B', height: '1px' }} />
    </DialogInfoGraphic>
  );
};
